import React from 'react';

import { FieldDisplayMode } from 'common/constants/ideas';
import { FieldModeDataMap } from 'common/subdomain/admin/v2/constants';
import Field from 'common/uiV3/Field';
import { Select } from 'common/uiV3/Select';

import type { CustomFieldFormState } from 'common/subdomain/admin/v2/hooks/useIdeaFieldForm';

type Props = {
  defaultMode?: FieldDisplayMode;
  setValue: <K extends keyof CustomFieldFormState, V>(key: K, value: V) => void;
};

const ModeOptions = Object.keys(FieldModeDataMap).map((mode) => {
  const { label, icon: Icon } = FieldModeDataMap[mode as FieldDisplayMode];

  return {
    value: mode,
    label: (
      <Select.OptionLabel>
        {<Icon />} {label}
      </Select.OptionLabel>
    ),
  };
});

export default function DisplayModeInputs({
  defaultMode = FieldDisplayMode.standard,
  setValue,
}: Props) {
  const onModeChange = (mode: string | undefined) => {
    if (!mode) {
      return;
    }

    setValue('displayMode', mode as FieldDisplayMode);
  };

  return (
    <Field>
      <Field.Label>Display mode</Field.Label>
      <Field.Description>Choose the way this field is displayed.</Field.Description>
      <Field.Content>
        <Select
          options={ModeOptions}
          value={defaultMode}
          onValueChange={onModeChange}
          placeholder="Standard"
        />
      </Field.Content>
    </Field>
  );
}
